<div>
    <mat-label class="label" [ngStyle]="captionStyles()">
        {{ question.Caption | qnaTranslate }}
    </mat-label>
</div>